var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { UXPContext } from "@core/context/Context";
import ButtonListContext from "./ButtonListContext";
import { useHasMobileCloseBar } from "@core/layout/MobileLayer";
import ButtonComponent from "./ButtonComponent";
// FontAwesome icon mapping for backward compatibility
const getIconClass = (type) => {
    const iconMap = {
        "search": "fal search",
        "close": "fal times",
        "done": "fal check",
        "arrow-up": "fal arrow-up",
        "arrow-down": "fal arrow-down",
        "arrow-left": "fal arrow-left",
        "arrow-right": "fal arrow-right",
        "filter": "fal filter",
        "edit": "fal pencil",
        "delete": "fal trash",
        "pin": "fal thumbtack",
        "copy": "fal copy",
        "plus": "fal plus"
    };
    return iconMap[type];
};
// A default label for each type: screen readers, and press and hold on touch screens
const TYPE_LABELS = {
    search: 'uxp-core.text.search',
    close: 'uxp-core.text.close',
    done: 'uxp-core.text.done',
    filter: 'uxp-core.text.filters',
    edit: 'uxp-core.text.edit',
    delete: 'uxp-core.text.delete',
    pin: 'uxp-core.text.pin',
    copy: 'uxp-core.text.copy',
    plus: 'uxp-core.text.add',
};
/**
 * Icon button component with set of default icons and options to render any icon
 * @export
 *
 *
 * @example
 * ```
 *  <IconButton
 *      type="search"
 *      onClick={()=> {alert("Clicked")}}
 *      className="custom-css-class"
 *  />
 * ```
 *
 *
 * @example
 * ```
 *  <IconButton
 *      icon="fas search"
 *      ...
 *  />
 * ```
 *
 *
 * @category Buttons
 */
const IconButton = (props) => {
    var _a;
    const { type, borderless, icon, buttonType } = props, rest = __rest(props, ["type", "borderless", "icon", "buttonType"]);
    const context = useContext(UXPContext);
    const typeLabel = type && TYPE_LABELS[type] ? (_a = context === null || context === void 0 ? void 0 : context.$L) === null || _a === void 0 ? void 0 : _a.call(context, TYPE_LABELS[type]) : undefined;
    // Phones: a close button moved into a sheet or the toolbar is left out while the footer
    // Close bar shows (it and Back already close the screen)
    const inSheetList = !!useContext(ButtonListContext);
    const hasCloseBar = useHasMobileCloseBar();
    if (type === 'close' && inSheetList && hasCloseBar)
        return null;
    // Handle borderless styling
    const borderlessStyles = borderless ? { border: 'none' } : {};
    // Get FontAwesome icon class for backward compatibility
    const iconClass = type ? getIconClass(type) : icon || undefined;
    return (_jsx(ButtonComponent, Object.assign({ leftIcon: iconClass, iconOnly: true, styles: borderlessStyles, type: buttonType || 'button', ariaLabel: typeLabel }, rest)));
};
export default IconButton;
